import Footer from './components/Footer.vue'
import LogoIcon from './components/LogoIcon.vue'
export default [
    Footer,
    LogoIcon
]